module.exports = __webpack_public_path__ + "img/menu-dma.df5e81f0.png";